import { createComponent, createHook } from 'reakit-system';
import { cx, ecss } from '../reexports/emotion';
import { LinkHTMLProps, LinkOptions, useLink } from '../Link/Link';
import { WHCM } from '../constants';

/**
 * @beta
 */

type CrumbOptions = LinkOptions & {
  noShrink?: boolean;
};

export type CrumbProps = CrumbOptions & LinkHTMLProps;

const useCrumb = createHook<CrumbOptions, LinkHTMLProps>({
  name: 'Crumb',
  keys: ['noShrink'],
  compose: [useLink],
  useComposeOptions(options) {
    return {
      ...options,
      styles: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textDecoration: 'none',
        color: 'breadcrumbsColor',
        fontSize: 'fs-14',
        borderRadius: 'breadCrumb',
        '&:hover': {
          color: 'breadcrumbsHoverColor',
        },
        '&:active': {
          color: 'breadcrumbsActiveColor',
        },
        '&:focus, &:focus-visible': {
          boxShadow: 'focus',
          outline: 0,
        },

        [WHCM]: {
          '&:focus, &:focus-visible': {
            outline: 'auto',
          },
        },
      },
    };
  },
  useProps(options, props) {
    return {
      ...props,
      className: cx(
        props.className,
        ecss({
          label: 'Crumb',
        })
      ),
    };
  },
});

export const Crumb = createComponent({
  as: 'a',
  useHook: useCrumb,
  memo: true,
});
